import { render, staticRenderFns } from "./UpsertBooking.vue?vue&type=template&id=687c1db2&scoped=true&lang=pug&"
import script from "./UpsertBooking.vue?vue&type=script&lang=js&"
export * from "./UpsertBooking.vue?vue&type=script&lang=js&"
import style0 from "./UpsertBooking.vue?vue&type=style&index=0&id=687c1db2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c1db2",
  null
  
)

export default component.exports